import { render, staticRenderFns } from "./OtherLoanCaseDetails.vue?vue&type=template&id=e3349dfa"
import script from "./OtherLoanCaseDetails.vue?vue&type=script&lang=js"
export * from "./OtherLoanCaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports